var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRevenue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 159.82 127.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#505050;}.cls-2{fill:#9ca5ad;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.48,
    y: 91.78,
    width: 28.65,
    height: 35.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.27,
    y: 106.97,
    width: 28.65,
    height: 20.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.71,
    y: 75.11,
    width: 28.65,
    height: 52.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 124.95,
    y: 58.73,
    width: 28.66,
    height: 68.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.21,91.18a2.11,2.11,0,0,1-1.37-.35A1.83,1.83,0,0,1,.4,88.15L20.53,62.31A2.18,2.18,0,0,1,23,61.66l23.82,9.22L65.52,40.61a2.15,2.15,0,0,1,3-.58L92.21,56.92,106.12,26a2,2,0,0,1,1.18-1.07,2.17,2.17,0,0,1,1.62.07L131,35,151,4.45a2.14,2.14,0,0,1,2.82-.66,1.82,1.82,0,0,1,.67,2.63l-21,32.1a2.15,2.15,0,0,1-2.66.74L109,29.33,94.94,60.68a2.05,2.05,0,0,1-1.36,1.12,2.15,2.15,0,0,1-1.78-.32L67.89,44.41,49.44,74.24a2.12,2.12,0,0,1-2.57.83l-24-9.28L3.7,90.39A2.09,2.09,0,0,1,2.21,91.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M157.93,15.94a2,2,0,0,1-2.16-1.45L153.2,4.41,140.88,8.32a2.06,2.06,0,0,1-2.58-1.2,1.91,1.91,0,0,1,1.31-2.43L154,.1a2.19,2.19,0,0,1,1.63.13,1.89,1.89,0,0,1,1,1.22l3.09,12.11a1.93,1.93,0,0,1-1.51,2.33Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenue);
export default __webpack_public_path__ + "static/media/revenue.79ad2dedf81699ac4023e39de2a036da.svg";
export { ForwardRef as ReactComponent };